module.exports = __webpack_public_path__ + "img/allottee1_7-8-2021.2fd1f21c.jpg";